<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 230 230"
    version="1.1"
  >
    <path
      d="M 103.724 51.480 C 92.056 55.910, 84.108 66.173, 82.232 79.231 L 81.475 84.500 67.964 84.777 L 54.453 85.053 58.105 119.559 C 60.114 138.537, 62.322 156.079, 63.012 158.542 C 64.670 164.464, 71.173 171.706, 77.462 174.634 C 82.422 176.944, 83 176.980, 115 176.980 C 147 176.980, 147.578 176.944, 152.538 174.634 C 158.425 171.893, 165.527 164.309, 167.089 159.098 C 167.684 157.111, 169.838 139.739, 171.875 120.493 L 175.579 85.500 162.051 85 L 148.523 84.500 147.740 79.043 C 146.089 67.542, 139.129 57.700, 129.193 52.817 C 123.355 49.948, 109.653 49.228, 103.724 51.480 M 107.239 65.597 C 102.777 67.873, 98.321 73.181, 97.060 77.723 C 94.911 85.463, 93.761 85, 115.128 85 L 134.256 85 133.577 80.755 C 132.699 75.267, 130.411 71.448, 125.735 67.669 C 121.046 63.879, 112.486 62.920, 107.239 65.597"
      stroke="none"
      fill="#fbfbfb"
      :style="{ fill: $attrs.bgColor }"
      fill-rule="evenodd"
    />
    <path
      d="M 94.500 0.618 C 72.023 2.958, 58.016 6.467, 44.933 13.038 C 21.320 24.897, 8.018 45.662, 2.356 79.500 C -0.246 95.050, -0.236 134.744, 2.374 150.500 C 10.139 197.377, 33.267 220.331, 80.142 227.680 C 96.097 230.182, 133.903 230.182, 149.858 227.680 C 189.062 221.533, 211.447 204.311, 222.620 171.700 C 225.448 163.446, 229 144.103, 229 136.960 C 229 134.297, 229.450 131.840, 230 131.500 C 230.607 131.125, 230.994 123.923, 230.985 113.191 C 230.974 101.399, 230.646 96, 230 97 C 229.305 98.076, 229.026 97.044, 229.015 93.349 C 228.993 85.890, 225.485 66.662, 222.620 58.300 C 211.558 26.011, 189.032 8.483, 150.907 2.498 C 140.895 0.926, 103.509 -0.320, 94.500 0.618 M 103.724 51.480 C 92.056 55.910, 84.108 66.173, 82.232 79.231 L 81.475 84.500 67.964 84.777 L 54.453 85.053 58.105 119.559 C 60.114 138.537, 62.322 156.079, 63.012 158.542 C 64.670 164.464, 71.173 171.706, 77.462 174.634 C 82.422 176.944, 83 176.980, 115 176.980 C 147 176.980, 147.578 176.944, 152.538 174.634 C 158.425 171.893, 165.527 164.309, 167.089 159.098 C 167.684 157.111, 169.838 139.739, 171.875 120.493 L 175.579 85.500 162.051 85 L 148.523 84.500 147.740 79.043 C 146.089 67.542, 139.129 57.700, 129.193 52.817 C 123.355 49.948, 109.653 49.228, 103.724 51.480 M 107.239 65.597 C 102.777 67.873, 98.321 73.181, 97.060 77.723 C 94.911 85.463, 93.761 85, 115.128 85 L 134.256 85 133.577 80.755 C 132.699 75.267, 130.411 71.448, 125.735 67.669 C 121.046 63.879, 112.486 62.920, 107.239 65.597 M 0.413 114.500 C 0.414 124.400, 0.564 128.315, 0.746 123.199 C 0.928 118.084, 0.927 109.984, 0.744 105.199 C 0.561 100.415, 0.412 104.600, 0.413 114.500"
      stroke="none"
      fill="#ec3c75"
      :style="{ fill: $attrs.fgColor }"
      fill-rule="evenodd"
    />
  </svg>
</template>

<script>
export default {
  name: "svgSamsungstore",
  props: {
    height: [String, Number],
    width: [String, Number],
  },
};
</script>

<style></style>
